import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\LocalLandingController::region
* @see app/Http/Controllers/LocalLandingController.php:24
* @route '/pronajem-bagru/{region}'
*/
export const region = (args: { region: string | number } | [region: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: region.url(args, options),
    method: 'get',
})

region.definition = {
    methods: ["get","head"],
    url: '/pronajem-bagru/{region}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LocalLandingController::region
* @see app/Http/Controllers/LocalLandingController.php:24
* @route '/pronajem-bagru/{region}'
*/
region.url = (args: { region: string | number } | [region: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { region: args }
    }

    if (Array.isArray(args)) {
        args = {
            region: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        region: args.region,
    }

    return region.definition.url
            .replace('{region}', parsedArgs.region.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LocalLandingController::region
* @see app/Http/Controllers/LocalLandingController.php:24
* @route '/pronajem-bagru/{region}'
*/
region.get = (args: { region: string | number } | [region: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: region.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LocalLandingController::region
* @see app/Http/Controllers/LocalLandingController.php:24
* @route '/pronajem-bagru/{region}'
*/
region.head = (args: { region: string | number } | [region: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: region.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LocalLandingController::district
* @see app/Http/Controllers/LocalLandingController.php:83
* @route '/pronajem-bagru/{region}/{district}'
*/
export const district = (args: { region: string | number, district: string | number } | [region: string | number, district: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: district.url(args, options),
    method: 'get',
})

district.definition = {
    methods: ["get","head"],
    url: '/pronajem-bagru/{region}/{district}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LocalLandingController::district
* @see app/Http/Controllers/LocalLandingController.php:83
* @route '/pronajem-bagru/{region}/{district}'
*/
district.url = (args: { region: string | number, district: string | number } | [region: string | number, district: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            region: args[0],
            district: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        region: args.region,
        district: args.district,
    }

    return district.definition.url
            .replace('{region}', parsedArgs.region.toString())
            .replace('{district}', parsedArgs.district.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LocalLandingController::district
* @see app/Http/Controllers/LocalLandingController.php:83
* @route '/pronajem-bagru/{region}/{district}'
*/
district.get = (args: { region: string | number, district: string | number } | [region: string | number, district: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: district.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LocalLandingController::district
* @see app/Http/Controllers/LocalLandingController.php:83
* @route '/pronajem-bagru/{region}/{district}'
*/
district.head = (args: { region: string | number, district: string | number } | [region: string | number, district: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: district.url(args, options),
    method: 'head',
})

